import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import { HOURS_PER_WEEK, PART_FULL_TIME } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW } from "../../../shared/constants/Constants";
import Modalpopup from "../../../shared/components/Modalpopup";
import { loadFullPartTimeDataRequest, loadFullPartTimeDeleteDataRequest } from "../redux/Actions";
import FullPartTimeAdd from "./FullPartTimeAdd";
import FullPartTimeEdit from "./FullPartTimeEdit";
import DeleteModal from "../../../shared/components/DeleteModal";
import Permissions from "../../../shared/components/Permissions";

const FullPartTime = () => {
    let dispatch = useDispatch();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    let { fullPartTimes, loading } = useSelector((state) => state.fullPartTime);
    let [selectedRow, setSelectedRow] = useState({})

    let [shouldReload, setShouldReload] = useState(true)

    useEffect(() => {
        if (shouldReload && !loading) {
            setShouldReload(false);
            dispatch(loadFullPartTimeDataRequest());
        }
    }, [dispatch, loading, shouldReload]);

    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "Part Full Time Status";
    let permission = Permissions(emp_no, module_name);

    let actionsPermission = !(permission.write_permission || permission.delete_permission);

    let columns = [
        {
            display_name: PART_FULL_TIME,
            field: "name",
            type: "text",
        },
        {
            display_name: HOURS_PER_WEEK,
            field: "hours_per_week",
            type: "text",
        },
        {
            display_name: "",
            field: 'actions',
            type: 'actions',
            hide: actionsPermission
        }
    ];

    const handleDelete = () => {
        dispatch(loadFullPartTimeDeleteDataRequest({ id: [selectedRow] }))
        setShouldReload(true)
        setShowDeleteModal(false);
    }

    
    let [clickEditFunc, setClickEditFunc] = useState(null);
    let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
    useEffect(()=>{
        if (permission.write_permission){
            setClickEditFunc(
                () => (row)=>{
                setSelectedRow(row);
                setShowEditModal(true);
            })
        }
        if (permission.delete_permission){
            setClickDeleteFunc(
                () => (id)=>{
                setSelectedRow(id);
                setShowDeleteModal(true);
            })
        }
    },[permission])

    return (
        <>
            <Row>
                <Col className="gx-0">
                    <Breadcrumbs
                        children={[
                            { href: '/density', label: PART_FULL_TIME },
                        ]}
                    />
                </Col>
                <Col xs="auto" className="gx-0">
                    {permission.create_permission ? (
                            <DefaultButton
                                buttonClass="btn btn-primary default-btn-color"
                                buttonTitle={CREATENEW}
                                actionBlock={() => setShowCreateModal(true)}
                            />
                    ) : ""}
                </Col>
            </Row>
            <Row>
                <Card>
                    <Card.Body>
                        <ListView
                            exportTitle={PART_FULL_TIME}
                            columnNames={columns}
                            rowData={fullPartTimes}
                            clickEdit={clickEditFunc}
                            clickDelete={clickDeleteFunc}
                        />
                    </Card.Body>
                </Card>
            </Row>
            <Modalpopup
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                actionTitle={"Create " + PART_FULL_TIME}
            >
                <FullPartTimeAdd
                    handleClose={(reload) => {
                        setShowCreateModal(false);
                        if (reload) {
                            dispatch(loadFullPartTimeDataRequest());
                        }
                    }}
                />
            </Modalpopup>
            <Modalpopup
                show={showEditModal}
                handleClose={() => { setShowEditModal(false) }}
                actionTitle={"Edit " + PART_FULL_TIME}
            >
                <FullPartTimeEdit
                    fullPartTime={selectedRow}
                    handleClose={(reload) => {
                        if (reload) {
                            dispatch(loadFullPartTimeDataRequest());
                        }
                        setShowEditModal(false)
                    }}
                />
            </Modalpopup>
            <DeleteModal
                handleClose={() => { setShowDeleteModal(false) }}
                handleDelete={handleDelete}
                show={showDeleteModal}
            >
                <div>
                    Delete {PART_FULL_TIME}?
                </div>
            </DeleteModal>
        </>
    );
};

export default FullPartTime;
